import * as $http from 'axios'

export default {
    get: orderId => $http.get(`v2/orders/${orderId}`),
    tossPayment: payload => $http.post(`v2/orders/toss_payments_notification`, payload),
}
